import { Component, SimpleChanges, Input, forwardRef, ElementRef, Renderer2, Output } from '@angular/core';

import { ComponentBase } from '@framework/base/component/component.base';
import { Constants } from '../../../constants';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-grid-view-dynamic-field',
  templateUrl: './grid-view-dynamic-field.component.html',
  styleUrls: ['./grid-view-dynamic-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GridViewDynamicFieldComponent),
      multi: true
    }
  ]
})
export class GridViewDynamicFieldComponent extends ComponentBase implements ControlValueAccessor {
  @Input() type: string;
  @Input() disabled: boolean = false;
  @Input() item:any;
  @Input() columnName:any;
  @Output() 

  // Private variables
  private inputValue: string;
  public toggleColor:any;
  public enable_scheduling:any;
  today = new Date().toLocaleDateString();
  // Public variables
  public fnOnChange: any = () => { };
  public fnOnTouch: any = () => { };

  constructor(private el: ElementRef, private renderer: Renderer2) {
    super();
  }

  // Life cycle hook
  protected onInit(): void {
    this.enable_scheduling = localStorage.getItem('enable_scheduling')
    this.subscribe();
  }
  protected onDestroy(): void {
    this.unsubscribe();
  }
  protected onChanges(changes: SimpleChanges): void {

  }
  protected onDoCheck(): void {

  }
  protected onAfterContentInit(): void {

  }
  protected onAfterContentChecked(): void {

  }
  protected onAfterViewInit(): void {

  }
  protected onAfterViewChecked(): void {

  }
  protected ionViewDidLoad(): void {

  }
  protected ionViewWillEnter(): void {

  }
  protected ionViewDidEnter(): void {

  }
  protected ionViewWillLeave(): void {

  }
  protected ionViewDidLeave(): void {

  }
  protected ionViewWillUnload(): void {

  }

  // Private functions
  private subscribe() {
    this.toggleColor = localStorage.getItem('toggleColor')
     this.toggleColor = this.toggleColor ? this.toggleColor : ''
  }

  
  getScheduledTime(item: any): Date | null {
    if(item && item.scheduler_data){
      return item?.scheduler_data?.internal_scheduled_time || item?.scheduler_data?.public_scheduled_time || null;
    }

  }

  // Get the appropriate toggle color based on scheduling status
  public getToggleColor(): string {
    if (!this.value) return ''; // Toggle is OFF, no background color
    
    // Check if this is a scheduled story and we're rendering a checkbox
    if (this.item && this.type === Constants.columnType.schedulerCheckbox) {
      
      // Load scheduled data from localStorage
      const scheduleKey = `story_schedule_${this.item.id}`;
      const existingSchedule = localStorage.getItem(scheduleKey);
      
      if (existingSchedule) {
        try {
          const scheduleData = JSON.parse(existingSchedule);
          
          // For Internal column: check if this toggle represents internal status and has scheduled date
          if (this.value === this.item.is_internal_story_approved && scheduleData.internalScheduledAt) {
            const scheduledDate = new Date(scheduleData.internalScheduledAt);
            const now = new Date();
            
            // Only show orange if scheduled for future
            if (scheduledDate > now) {
              console.log('Internal scheduled detected - returning orange');
              return '#FF8C00'; // Orange for internal scheduled
            }
          }
          
          // For Public column: check if this toggle represents public status and has scheduled date  
          if (this.value === this.item.public && scheduleData.publicScheduledAt) {
            const scheduledDate = new Date(scheduleData.publicScheduledAt);
            const now = new Date();
            
            // Only show blue if scheduled for future
            if (scheduledDate > now) {
              console.log('Public scheduled detected - returning blue');
              return '#007BFF'; // Blue for public scheduled
            }
          }
        } catch (e) {
          console.error('Error parsing schedule data:', e);
        }
      }
    }
    
    // Default color for regular published stories
    return this.toggleColor;
  }

  private unsubscribe() {

  }

  private triggerChange($event) {
    this.fnOnChange($event);
    const event = new CustomEvent('change', { bubbles: true });
    this.el.nativeElement.dispatchEvent(event);
  }
  // Public functions
  public get isText(): boolean {
    return this.type === Constants.columnType.text;
  }

  public get isCheckBox(): boolean {
    return this.type === Constants.columnType.checkbox;
  }


  public get isScheduler(): boolean {
    return this.type === Constants.columnType.schedulerCheckbox;
  }

  public get isNullableCheckBox(): boolean {
    return this.type === Constants.columnType.nullablecheckbox;
  }
  public get isDate(): boolean {
    return this.type === Constants.columnType.date;
  }

  public get isStatus(): boolean {
    return this.type === Constants.columnType.status;
  }

  public get isIcon(): boolean {
    return this.type === Constants.columnType.icon;
  }

  public get isdIcon(): boolean {
    return this.type === Constants.columnType.dicon;
  }

  public get consentflag(): boolean {
    return this.type === Constants.columnType.consentflag;
  }


  public get isColor(): boolean {
    return this.type === Constants.columnType.color;
  }

  public get isModal(): boolean {
    return this.type === Constants.columnType.modal;
  }


  public get isRequestdDraftLink(): boolean {
    return this.type === Constants.columnType.requestedDraftLink;
  }

   isStringss(value): boolean{
    if(typeof value === 'string' && !value.includes('xml')){
      return true;
    }
    else{
      return false;
    }
  }

  public get isThumbnail(): boolean {
    return this.type === Constants.columnType.thumbnail;
  }
  public get isdsvgThumbnail(): boolean {
    return this.type === Constants.columnType.dsvgthumbnail;
  }

  public get isScheduleIcon(): boolean {
    return this.type === Constants.columnType.scheduleIcon;
  }

  public get isScheduled(): boolean {
    // Check if the story has any scheduled dates
    return this.item && (this.item.internalScheduledAt || this.item.publicScheduledAt);
  }


  public set value(val: string) {
    // if (val !== undefined && val !== null) {
      this.inputValue = val;
    // }
  }

  public get value() {
    return this.inputValue;
  }

  public get background() {
    return `url(${this.value})`;
  }

  public writeValue(val: string): void {
    this.value = val;
  }


  public registerOnChange(fn: any): void {
    this.fnOnChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.fnOnTouch = fn;
  }

  public onChange(event?: Event) {
    // Prefer the native checkbox state so we don't emit the pre-click value
    // when (change) fires before ngModel updates.
    if (event?.target && 'checked' in (event.target as HTMLInputElement)) {
      const checked = (event.target as HTMLInputElement).checked;
      this.inputValue = checked as any;
      this.triggerChange(checked);
      return;
    }
    this.triggerChange(this.inputValue);
  }

  oncolorChange(event){
    //console.log("vall>>",event)
    if(event != null && event != undefined){
      this.triggerChange(event);
    }

  }
  public onClick(){
    this.triggerChange("clickData");
  }
  public openModalLink(){
    this.triggerChange(this.inputValue);
  }

  public copyLink(){
    this.triggerChange(this.inputValue);
  }

  public showConsentModal(){
    this.triggerChange(this.inputValue);
  }

  public onScheduleClick() {
    this.triggerChange('schedule_click');
  }

  public getScheduleTooltip(): string {
    if (this.isScheduled) {
      return 'Story has scheduled publishing times - click to modify';
    }
    return 'Click to schedule story publishing';
  }
}

